// extracted by mini-css-extract-plugin
export default {"flag":"Fx3CV7"};